export const firebaseConfig = {
    apiKey: "AIzaSyAmCghJdMvcKxDMCmQVQ2lDwvEM0e-DLQ4",
    authDomain: "halloween-candy-dispenser.firebaseapp.com",
    databaseURL: "https://halloween-candy-dispenser.firebaseio.com",
    projectId: "halloween-candy-dispenser",
    storageBucket: "halloween-candy-dispenser.appspot.com",
    messagingSenderId: "489903711579",
    appId: "1:489903711579:web:b31f80544c27adeb73667e"
  };
